import styled, { css } from 'foundations-theming/utils';
const BALL_RADIUS = 15;
const StyledPlaceholder = styled.div.withConfig({
  displayName: "StyledPlaceholder"
})([".hs-private.hs-private.hs-private &{z-index:1;pointer-events:none;position:absolute;", " ", " ", " ", " ", " ", "}"], ({
  display
}) => css(["display:", ";"], display), ({
  isVertical
}) => isVertical ? css(["top:", "px;bottom:", "px;"], BALL_RADIUS / 2, BALL_RADIUS / 2) : css(["left:", "px;right:", "px;"], BALL_RADIUS / 2, BALL_RADIUS / 2), ({
  isVertical,
  positionInFlow
}) => isVertical && positionInFlow === 'before' && css(["left:0;"]), ({
  isVertical,
  positionInFlow
}) => isVertical && positionInFlow === 'after' && css(["right:0;"]), ({
  isVertical,
  positionInFlow
}) => !isVertical && positionInFlow === 'before' && css(["top:0;"]), ({
  isVertical,
  positionInFlow
}) => !isVertical && positionInFlow === 'after' && css(["bottom:0;"]));
export default StyledPlaceholder;